import _ from 'lodash';

export const INVENTORY_COUNT_STATUS = _.mapValues({
  completed: {
    color: 'success',
    label: 'Completed',
  },
  in_progress: {
    color: 'primary',
    label: 'In Progress',
  },
}, (val, key) => ({ ...val, key }));
